import { Typography } from '@mui/material';
import { ReactComponent as FilledHome } from '../../../../assets/icons/filled-home.svg';
import { ReactComponent as StokeHome } from '../../../../assets/icons/stoke-home.svg';
import { StyledHome } from '../styles/sx';
import { useLocation, useNavigate } from 'react-router-dom';
interface IProps {
  onHomeClicked: () => void;
}

const Home = ({ onHomeClicked }: IProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <StyledHome
      onClick={() => {
        onHomeClicked();
        navigate('/');
      }}
    >
      {location.pathname === '/' ? <FilledHome /> : <StokeHome />}
      <Typography
        variant="h6"
        sx={(theme) => ({
          color:
            location.pathname === '/' ? theme.palette.primary.main : theme.palette.text.secondary,
        })}
      >
        Home
      </Typography>
    </StyledHome>
  );
};
export default Home;
